import React, {useEffect, useState} from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import ProjectDetails from "../../components/ProjectDetails/ProjectDetails";
import Expertise from "../../containers/Expertise/Expertise";
import Experience from "../../containers/Experience/Experience";
import OpenSourceProjects from "../../containers/OpenSourceProjects/OpenSourceProjects";
import Projects from "../../containers/Projects/Projects";
import Achievement from "../../containers/achievement/Achievement";
import Footer from "../../components/footer/Footer";
import Talks from "../../containers/talks/Talks";
import Podcast from "../../containers/podcast/Podcast";
import Education from "../../containers/education/Education";
import ScrollToTopButton from "../../containers/topbutton/Top";
import Profile from "../../containers/profile/Profile";
import SplashScreen from "../../containers/splashScreen/SplashScreen";
import {splashScreen} from "../../portfolio";
import {StyleProvider} from "../../contexts/StyleContext";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import "./ProjectDetailsPage.scss";

const ProjectDetailsPage = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <main>
              <ProjectDetails />
            </main>
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default ProjectDetailsPage;
